import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class GlobalUtilsService {

	public static get isMobileDevice() {
		return navigator.userAgent.includes('Mobi');
	}

}
